import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ButtonContinue } from './Button/ButtonContinue';

interface Props {
  showDialog: boolean;
  path: string;
  onCloseModal: () => void;
  brandName: string;
}

const NavigationWarningDialog = ({
  showDialog,
  path,
  onCloseModal,
  brandName
}: Props): JSX.Element => {
  const navigate = useNavigate();

  const onClickClose = () => {
    onCloseModal();
  };

  const onClickContinue = () => {
    navigate(path);
    onCloseModal();
  };

  return (
    <Modal
      role='modal-popup'
      isOpen={showDialog}
      className={`insurance-${brandName}`}
      toggle={onClickClose}>
      <ModalHeader toggle={onClickClose}>Caution</ModalHeader>
      <ModalBody>
        Navigating off this page will lose any unsaved information
      </ModalBody>
      <ModalFooter>
        <ButtonContinue
          name='modal-btn-continue'
          text='Cancel'
          onClick={onClickClose}
          additionalClassNames='btn-ok'
        />
        <ButtonContinue
          name='modal-btn-continue'
          text='Continue'
          onClick={onClickContinue}
          additionalClassNames='btn-ok'
        />
      </ModalFooter>
    </Modal>
  );
};

export default NavigationWarningDialog;
